import { config } from 'lib/config'

export const getPortalUrlWithParams = () => {
  const baseUrl = `https://${config.API_BASE_URL}/applicant`

  const masterId = localStorage.getItem('masterId')
  const countyId = localStorage.getItem('countyId')
  const districtId = localStorage.getItem('districtId')

  const params = new URLSearchParams()

  if (masterId) params.append('masterId', masterId)
  if (countyId) params.append('countyId', countyId)
  if (districtId) params.append('districtId', districtId)

  const queryString = params.toString()

  return queryString ? `${baseUrl}?${queryString}` : baseUrl
}
